import styled from 'styled-components';

import { config } from '_config';
import { theme } from '_constants/theme';

import Card from '_components/atomic/layouts/Card';

const StyledOuterContainer = styled.div`
  max-width: ${theme.spaces.large23X * 10 + 10}px;
  width: 100%;
`;

const StyledInnerContainer = styled.div`
  padding-top: ${theme.spaces.large6X}px;
  padding-bottom: ${theme.spaces.large6X}px;
  padding-left: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
`;

const PrivacySection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Card.Text
          size={theme.fontSizes.large2X}
          weight={600}
          bottomSpace={theme.spaces.large}
          desktop
        >
          Privacy Policy
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.large}
          weight={600}
          bottomSpace={theme.spaces.large}
          mobile
        >
          Privacy Policy
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Effective Date: 05/15/2024
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          1. Introduction
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Incorpified (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) is
          committed to protecting your privacy. This Privacy Policy explains how
          we collect, use, disclose, and safeguard your information when you
          visit our website www.incorpified.com (the &quot;Site&quot;). Please
          read this Privacy Policy carefully. If you do not agree with the terms
          of this Privacy Policy, please do not access the Site.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          2. Information We Collect
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          We may collect information about you in a variety of ways. The
          information we may collect on the Site includes:
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          <b>Personal Data:</b> Personally identifiable information, such as
          your name, shipping address, email address, and telephone number, and
          demographic information, such as your age, gender, hometown, and
          interests, that you voluntarily give to us when you register with the
          Site or when you choose to participate in various activities related
          to the Site.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          <b>Derivative Data:</b> Information our servers automatically collect
          when you access the Site, such as your IP address, your browser type,
          your operating system, your access times, and the pages you have
          viewed directly before and after accessing the Site.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          <b>Financial Data:</b> Financial information, such as data related to
          your payment method (e.g., valid credit card number, card brand,
          expiration date) that we may collect when you purchase, order, return,
          exchange, or request information about our services from the Site.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          <b>Data From Social Networks:</b> User information from social
          networking sites, such as Facebook, Google+, Instagram, including your
          name, your social network username, location, gender, birth date,
          email address, profile picture, and public data for contacts, if you
          connect your account to such social networks.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          3. Use of Your Information
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          We use the information we collect in the following ways:
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          <ul>
            <li>To facilitate account creation and the logon process.</li>
            <li>To send you marketing and promotional communications.</li>
            <li>
              To deliver targeted advertising, coupons, newsletters, and other
              information regarding promotions and the Site to you.
            </li>
            <li>
              To request feedback and contact you about your use of the Site.
            </li>
            <li>
              To protect the Site and prevent fraudulent transactions, monitor
              against theft, and protect against criminal activity.
            </li>
          </ul>
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          4. Disclosure of Your Information
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          We may share information we have collected about you in certain
          situations. Your information may be disclosed as follows:
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          <b>By Law or to Protect Rights:</b> If we believe the release of
          information about you is necessary to respond to legal process, to
          investigate or remedy potential violations of our policies, or to
          protect the rights, property, and safety of others, we may share your
          information as permitted or required by any applicable law, rule, or
          regulation.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          <b>Business Transfers:</b> We may share or transfer your information
          in connection with, or during negotiations of, any merger, sale of
          company assets, financing, or acquisition of all or a portion of our
          business to another company.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          5. Security of Your Information
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          We use administrative, technical, and physical security measures to
          help protect your personal information. While we have taken reasonable
          steps to secure the personal information you provide to us, please be
          aware that despite our efforts, no security measures are perfect or
          impenetrable, and no method of data transmission can be guaranteed
          against any interception or other type of misuse.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          6. Policy for Children
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          We do not knowingly solicit information from or market to children
          under the age of 18. If we learn we have collected personal
          information from a child under age 18 without verification of parental
          consent, we will delete that information as quickly as possible.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          7. Changes to This Privacy Policy
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          We may update this Privacy Policy from time to time. You are
          encouraged to periodically review this Privacy Policy to stay informed
          of updates. We will notify you of any changes by updating the
          “Effective Date” of this Privacy Policy. Your continued use of the
          Site after the date such revised policy is posted will constitute your
          acceptance of the changes.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          8. Contact Us
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          If you have questions or comments about this Privacy Policy, please
          contact us at:&nbsp;
          <a href={`mailto:${config.email}`}>{config.email}</a>
        </Card.Text>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default PrivacySection;
